export default __webpack_public_path__ + "locales/it/InfoPanel.json?hash=f4a938a2bf20a7ab0dfd52c0bc81834a";